import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsPodWorkflowsetsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPartsPodWorkflowsetsQuery = { __typename?: 'query_root', workflowsets: Array<{ __typename?: 'workflowsets', id: number, name: string, description: string, parts_pod_workflow_id?: number | null }> };


export const GetPartsPodWorkflowsetsDocument = gql`
    query getPartsPodWorkflowsets($customerId: bigint!) {
  workflowsets(
    where: {customer_id: {_eq: $customerId}, parts_pod_workflow_id: {_is_null: false}}
    order_by: {name: asc}
  ) {
    id
    name
    description
    parts_pod_workflow_id
  }
}
    `;

/**
 * __useGetPartsPodWorkflowsetsQuery__
 *
 * To run a query within a React component, call `useGetPartsPodWorkflowsetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsPodWorkflowsetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsPodWorkflowsetsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPartsPodWorkflowsetsQuery(baseOptions: Apollo.QueryHookOptions<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables> & ({ variables: GetPartsPodWorkflowsetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>(GetPartsPodWorkflowsetsDocument, options);
      }
export function useGetPartsPodWorkflowsetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>(GetPartsPodWorkflowsetsDocument, options);
        }
// @ts-ignore
export function useGetPartsPodWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>;
export function useGetPartsPodWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsPodWorkflowsetsQuery | undefined, GetPartsPodWorkflowsetsQueryVariables>;
export function useGetPartsPodWorkflowsetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>(GetPartsPodWorkflowsetsDocument, options);
        }
export type GetPartsPodWorkflowsetsQueryHookResult = ReturnType<typeof useGetPartsPodWorkflowsetsQuery>;
export type GetPartsPodWorkflowsetsLazyQueryHookResult = ReturnType<typeof useGetPartsPodWorkflowsetsLazyQuery>;
export type GetPartsPodWorkflowsetsSuspenseQueryHookResult = ReturnType<typeof useGetPartsPodWorkflowsetsSuspenseQuery>;
export type GetPartsPodWorkflowsetsQueryResult = Apollo.QueryResult<GetPartsPodWorkflowsetsQuery, GetPartsPodWorkflowsetsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsPodWorkflowsets.query.gql}
 */
export async function getPartsPodWorkflowsets(
  variables: GetPartsPodWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsPodWorkflowsetsQuery['workflowsets']>
export async function getPartsPodWorkflowsets(
  variables: GetPartsPodWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsPodWorkflowsetsQuery>
export async function getPartsPodWorkflowsets(
  variables: GetPartsPodWorkflowsetsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsPodWorkflowsetsQuery['workflowsets'] | GetPartsPodWorkflowsetsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsPodWorkflowsetsQuery>(
    GetPartsPodWorkflowsetsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.workflowsets
}